<template>
  <CreateNotificationForm />
</template>
